import { Directory } from "../../../domain/drawing";
import { FormatSet } from "../../../domain/format";
import { StringFilterParameter } from "../../system/filters";

export class FormatSetDirectoryFilterParameter {
  constructor(name: string = "") {
    this.name = new StringFilterParameter(name);
  }

  name: StringFilterParameter;

  filter(source: Directory<string, FormatSet>): boolean {
    return this.name.filter(source.name);
  }

  clone(): FormatSetDirectoryFilterParameter {
    return new FormatSetDirectoryFilterParameter(this.name.keyword);
  }
}
